import product1 from '../../assets/products/product1.png';
import product2 from '../../assets/products/product2.png';
import product3 from '../../assets/products/product3.png';
import product4 from '../../assets/products/product4.png';
import product5 from '../../assets/products/product5.png';
import product6 from '../../assets/products/product6.png';
import product7 from '../../assets/products/product7.png';
import product8 from '../../assets/products/product8.png';
import product9 from '../../assets/products/product9.png';

export const products_content = {
    header: {
        title: 'Products',
    },

    products: [
        {
            id: 1,
            name: 'TIPPING PAPER',
            description:
                'High-performance tipping paper available in matte, gloss, metallic, and textured finishes. Designed for smooth airflow, strong bonding, and consistent burn control.',
            image: product1,
        },
        {
            id: 2,
            name: 'LASER PERFORATED TIPPING PAPER',
            description:
                'Engineered with laser or electrostatic perforation for optimized airflow and uniform burn. Ensures superior smoke experience and filter performance.',
            image: product2,
        },
        {
            id: 3,
            name: 'INNER FRAME MATERIAL',
            description:
                'Rigid and durable paperboard inner frames that maintain pack shape and strength. Available in gold, silver, and custom finishes with luxury embossing.',
            image: product3,
        },
        {
            id: 4,
            name: 'HOT STAMPING FOIL',
            description:
                'High-quality metallic and custom foils for branding. Offers sharp image transfer, durable adhesion, and long-lasting shine at high-speed stamping.',
            image: product4,
        },
        {
            id: 5,
            name: 'CIGARETTE SEALING LABEL',
            description:
                'Tamper-proof sealing labels with embossing, holographic finishes, and heat-activated glue for instant sealing and visual distinction.',
            image: product5,
        },
        {
            id: 6,
            name: 'TEAR TAPE',
            description:
                'High-precision tear tapes with metallic, transparent, and holographic finishes. Designed for clean tear performance and brand enhancement.',
            image: product6,
        },
        {
            id: 7,
            name: 'PLASTIC BAGS',
            description:
                'Durable LDPE/HDPE bags for industrial and commercial use. Custom sizes, thickness, and printing options for secure packaging applications.',
            image: product7,
        },
        {
            id: 8,
            name: 'HOLOGRAPHIC PAPER',
            description:
                'Specialty holographic paper used for high-end packaging and anti-counterfeit protection. Offers light-reflective surface with premium appeal.',
            image: product8,
        },
        {
            id: 9,
            name: 'PRINTED CARTONS',
            description:
                'High-strength packaging boards supporting embossing, foil stamping, and high-resolution printing. Optimized for fast, precise packing lines.',
            image: product9,
        },
    ],
};